import { FormControl, Grid } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  TimePicker,
  renderTimeViewClock,
} from '@mui/x-date-pickers';
import { Control, Controller, FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import { gridSize } from "@/shared";
import dayjs from "dayjs";
interface TimeClockComponenteProps {
  control: Control<any, any>;
  name: string;
  error: FieldError | Merge<FieldError, FieldErrorsImpl<{ [x: string]: any; }>> | undefined;
  helperText?: string;
  label: string;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  }
  defaultValue?: string;
  enableDateTypeResult?: boolean;
  showTimeViewClock?: boolean;
  disabled?: boolean
}
export default function TimeClockComponente({ control,
  name,
  error,
  label,
  helperText,
  size = gridSize,
  defaultValue,
  enableDateTypeResult = false,
  showTimeViewClock = true,
  disabled = false,
}: Readonly<TimeClockComponenteProps>) {
  return (
    <Grid item {...size}>
      <FormControl fullWidth>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue ?? ''}
          render={({ field }) => {
            const onChange = (time: any) => {
              console.log("veamos", time)
              enableDateTypeResult ?
                field.onChange(new Date(time))
                : field.onChange(time);
            };
            return (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  {...field}
                  value={field.value ? dayjs(field.value) : null}
                  label={label}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: true,
                      helperText: helperText,
                    },
                  }}
                  views={['hours', 'minutes']}
                  viewRenderers={{
                    hours: showTimeViewClock ? renderTimeViewClock : null,
                    minutes: showTimeViewClock ? renderTimeViewClock : null,
                    seconds: showTimeViewClock ? renderTimeViewClock : null,
                  }}
                  onChange={onChange}
                  disabled={disabled}
                />
              </LocalizationProvider>
            );
          }}
        />
      </FormControl>
    </Grid>
  )
}